import { ExpiredSessionError } from '../client/error/errors';
import { loginApiUrl, LoginFetch } from './login-api';
import { yleLoginCookieKey } from '../common/utils';
import { LoggedInUser, Profile, ProfileCookies } from 'src/common/types';

export const fetchProfileCookie = async (loginFetch: LoginFetch) => {
  const response = await loginFetch('/user');
  const data: ProfileCookies = await response.json();
  return data;
};

export async function changeUserProfile(
  loginFetch: LoginFetch,
  profileCookie: string,
  subAccountId: string | null
): Promise<LoggedInUser> {
  const response = await loginFetch('/user', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      [yleLoginCookieKey]: profileCookie,
      subAccountId,
    }),
  });

  if (response.status === 401) {
    throw new ExpiredSessionError(
      'Session expired while changing profile',
      profileCookie
    );
  }

  const userData: LoggedInUser = await response.json();

  return userData;
}

export async function fetchSubAccounts(
  loginFetch: LoginFetch,
  profileCookies: string[]
): Promise<Profile[]> {
  const response = await loginFetch('/user/sub-accounts', {
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ loginCookies: profileCookies }),
    method: 'POST',
  });

  const { subProfiles }: { subProfiles: Profile[] } = await response.json();

  return subProfiles;
}

export async function patchUserProfile(
  loginFetch: LoginFetch,
  updatedValues: Partial<
    Pick<LoggedInUser, 'displayName'> & {
      avatar?: string | null;
      profileColor?: string | null;
    }
  >,
  loginCookie: string,
  subAccountId: string | null
): Promise<LoggedInUser> {
  if (Object.values(updatedValues).every(value => value === undefined)) {
    throw new Error('Nothing to update');
  }

  const response = await loginFetch('/user', {
    body: JSON.stringify({
      ...updatedValues,
      ...(subAccountId?.length ? { subAccountId } : {}),
      cookie: loginCookie,
    }),
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
  });

  const responseBody = await response.json();

  if (response.ok) {
    const updatedUser: LoggedInUser = responseBody;

    return updatedUser;
  }

  switch (response.status) {
    case 401:
      throw new ExpiredSessionError(
        'Session expired: ' + responseBody.message,
        loginCookie
      );
    default:
      throw new Error(responseBody.message);
  }
}

export async function fetchBrazeToken(loginFetch: LoginFetch): Promise<string> {
  const response = await loginFetch(`${loginApiUrl}/user/braze-token`);

  const body = await response.json();
  const token: string = body.token;

  return token;
}
